export default "__VITE_ASSET__3GnVI5VW__"